var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnplug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 24,
    transform: "matrix(1 0 0 -1 24 24)",
    fill: "#EEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.765 13-.755-.745-23.782 23.777.745.745 7.859-7.857c.091.195.138.408.137.623v6.869h1.057v-6.869a2.579 2.579 0 0 0-.417-1.395l4-4c.294.075.596.114.899.117h4.418v-1.532h2.51v-1.057h-2.51v-2.23h2.51V18.39H31.37L36.765 13zm-6.87 10.192h-3.319l3.32-3.323v3.323zM17.212 28.011h1.586l1.02-1.02a2.299 2.299 0 0 0-.333-.037h-2.267a2.944 2.944 0 0 1-2.162-5.065 2.944 2.944 0 0 1 2.162-.815h5.654c.107.724.427 1.401.92 1.944l.75-.75a2.642 2.642 0 0 1 1.998-4.375h2.378l1.057-1.057H26.54a3.7 3.7 0 0 0-3.668 3.17h-5.654a4.001 4.001 0 0 0-2.923 6.877A4 4 0 0 0 17.218 28l-.006.011z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12.255 12.255)",
    d: "M0 0h24.511v24.511H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnplug);
export default __webpack_public_path__ + "static/media/icon-unplug.45689576f7813d78431ab22c6db9ddbd.svg";
export { ForwardRef as ReactComponent };